import { render, staticRenderFns } from "./FormComparePhotos.vue?vue&type=template&id=1ea13112&scoped=true"
import script from "./FormComparePhotos.vue?vue&type=script&lang=js"
export * from "./FormComparePhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea13112",
  null
  
)

export default component.exports